export const mapAgentFromApiModel = ({
  data: {
    data: {
      id,
      attributes: { first_name, last_name, timezone },
    },
  },
}) => ({
  firstName: first_name,
  lastName: last_name,
  timeZone: timezone,
  id,
});
